import {ChangeDetectorRef, Component, Input, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import {ThingBypassInterface} from '@app/app/shared/interfaces/thing/thing-bypass.interface';
import {CommandsService} from '@app/app/shared/services/commands.service';

@Component({
  templateUrl: './park-bypass-item.html',
  selector: 'park-bypass-item'
})

export class ParkBypassItemComponent implements OnDestroy {
  @Input() public bypass: ThingBypassInterface;
  @Input() public bypassId: any;
  @Input() public parkId: any;
  @Input() public id: any;

  public isRunningAuto = false;
  public isRunningOpen = false;
  public isRunningClose = false;

  private timerSub: Subscription;

  private MODE_AUTO = 'auto';
  private MODE_OPEN = 'open';
  private MODE_CLOSE = 'close';

  constructor(private comm: CommandsService, private cdRef: ChangeDetectorRef) {
    //
  }

  /**
   * Set mode to auto
   */
  public setModeAuto() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningAuto = true;
      this.update(this.MODE_AUTO);
    }
  }

  /**
   * Set mode to manual
   */
  public setModeOpen() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningOpen = true;
      this.update(this.MODE_OPEN);
    }
  }

  /**
   * Set mode to off
   */
  public setModeClosed() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningClose = true;
      this.update(this.MODE_CLOSE);
    }
  }

  public isAuto() {
    const isAuto = (this.bypass.md === this.MODE_AUTO);

    if (isAuto && this.isRunningAuto) {
      this.isRunningAuto = false;
      this.cdRef.detectChanges();
    }

    return isAuto;
  }

  public isOpen() {
    const isOpen = (this.bypass.md === this.MODE_OPEN);

    if (isOpen && this.isRunningOpen) {
      this.isRunningOpen = false;
      this.cdRef.detectChanges();
    }

    return isOpen;
  }

  public isClose() {
    const isClose = (this.bypass.md === this.MODE_CLOSE);

    if (isClose && this.isRunningClose) {
      this.isRunningClose = false;
      this.cdRef.detectChanges();
    }

    return isClose;
  }

  public isRunning() {
    return (this.isRunningAuto || this.isRunningOpen || this.isRunningClose);
  }

  /**
   * Update activator
   */
  private update(mode: string) {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }

    this.comm.setBypassMode(this.parkId, this.id, this.bypassId, mode).then((res) => {
      this.timerSub = Observable.of(true).delay(8000).subscribe(() => {
        if (this.isRunningAuto && !this.isAuto()) {
          alert('Timed Out');
        }

        if (this.isRunningOpen && !this.isOpen()) {
          alert('Timed Out');
        }

        if (this.isRunningClose && !this.isClose()) {
          alert('Timed Out');
        }

        this.isRunningAuto = false;
        this.isRunningOpen = false;
        this.isRunningClose = false;
      });
    }).catch((err) => {
      this.isRunningAuto = false;
      this.isRunningOpen = false;
      this.isRunningClose = false;

      alert(err);
    });
  }

  ngOnDestroy() {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/controls/others/bypass/bypass-item/park-bypass-item.component.ts